export default __webpack_public_path__ + "static/phoneInHand-ac06c218d9a7a822ef69b6b7b31880dc.png";